// extracted by mini-css-extract-plugin
export default {"card-details__title":"CardDetails_card-details__title__FYm33"};